export default __webpack_public_path__ + "static/media/bg-11.46496051.jpg";